document.addEventListener("turbo:load", function(){
  $(document).on('change', '#range-name-select', function(event) {
    if (event.target.value == 'custom_dates') {
      $(this).closest('.range-name-picker').find('.collapse').collapse('show');
    } else {
      $(this).closest('.range-name-picker').find('.collapse').collapse('hide');
    }
  })
});